export class ModifierDetail {
	modifierDetailId: number;
	modifierDetailValue: string;
	priceAdjustment: number;
	isChecked: boolean;
	productOrProductGroup: number;
	productName: string;
	productId: number;
	productType: string;
	quantity: number;
	addOrRemove: string;
	order: number;
	rowNumberUp: number;
	rowNumberDown: number;
	rowNumber: number;
}